export default {"src":"/_next/static/media/group.a6992791.svg","height":18,"width":28,"blurWidth":0,"blurHeight":0};